// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Tooltip } from '@node-space/ui-components'
import { ExternalReferenceCta } from 'pages/EmbeddedCustomers/CustomerDetails/ExternalReference/ExternalReferenceCta'

export interface NestedCustomerExternalReferenceProps {
  reference: string
  externalReference: string | null
  refetchCustomerData: () => void
}

export const NestedCustomerExternalReference = ({
  reference,
  externalReference,
  refetchCustomerData,
}: NestedCustomerExternalReferenceProps) => {
  const { t } = useTranslation()

  return (
    <Box flex justify="between" align="center" className="py-[10px]">
      <Box flex gap={4} align="center">
        <h4 className="text-foreground-subdued text-body-regular">
          {t('customers.externalReference')}
        </h4>
        <Tooltip bodyContent={t('customers.externalReferenceTooltip')} type="complex" />
      </Box>
      <Box className="text-foreground-prominent text-body-strong text-right">
        <ExternalReferenceCta
          customerReference={reference}
          externalReference={externalReference}
          refetchCustomerData={refetchCustomerData}
        />
      </Box>
    </Box>
  )
}
